import type { DirectoryGroup } from "@p0security/shared/types/directory";
import { Typography } from "@p0security/ui";

import { snowflakeIamWriteInstaller } from "./iam-write/index.tsx";
import type { SnowflakeInstaller } from "./types.ts";

export const snowflakeInstaller = (
  groups?: DirectoryGroup[]
): SnowflakeInstaller => ({
  components: {
    base: {
      items: {},
    },
    "iam-write": snowflakeIamWriteInstaller(groups),
  },
  preamble: (
    <>
      <Typography.Paragraph>
        Enable IAM management for Snowflake with just-in-time access
        provisioning and support for SCIM user provisioning via Okta.
      </Typography.Paragraph>
      <Typography.Text strong>Prerequisites:</Typography.Text>
      <ul className="preamble-list">
        <li>
          <code>ACCOUNTADMIN</code> role privileges in Snowflake
        </li>
        <li>Snowflake account identifier</li>
      </ul>
    </>
  ),
});
